import axios from "axios";

export const BRANCHES_URL = `${process.env.REACT_APP_API_URL}/branches`;

// READ

export function getAllBranches() {
  return axios.get(BRANCHES_URL);
}

export function GetBranchById(branchId) {
  return axios.get(`${BRANCHES_URL}/${branchId}`);
}

// READ With Filters

export function FindBranches(queryParams) {
  return axios.get(BRANCHES_URL, {
    params: {
      pageSize: queryParams.pageSize,
      pageNumber: queryParams.pageNumber,
      name: queryParams.filter.name,
    },
  });
}

// Create
export function createBranch(branch) {
  return axios.post(`${BRANCHES_URL}/Create`, branch);
}

// Update
export function updateBranch(branch) {
  return axios.put(`${BRANCHES_URL}/Update`, branch);
}

// DELETE
export function deleteBranch(branchId) {
  return axios.delete(`${BRANCHES_URL}/Delete`, {
    params: {
      id: branchId,
    },
  });
}

export function ToggleLock(branchId){
  return axios.post(`${BRANCHES_URL}/ToggleLock`, {
    branchId
  });
}
